import "core-js/modules/es6.object.assign.js";

var defaultState = function defaultState() {
  return {
    updateReady: false,
    registration: null,
    refreshing: true,
    supportedDevice: false,
    updateComplete: false,
    pageLoading: false,
    pageLoadingType: ''
  };
};

var state = defaultState();
var getters = {
  GET_UPDATE_COMPLETE: function GET_UPDATE_COMPLETE(state) {
    return state.updateComplete;
  },
  GET_UPDATE_READY: function GET_UPDATE_READY(state) {
    return state.updateReady;
  },
  GET_APP_REGISTRATION: function GET_APP_REGISTRATION(state) {
    return state.registration;
  },
  GET_APP_REFRESHING: function GET_APP_REFRESHING(state) {
    return state.refreshing;
  },
  GET_PAGE_LOADING: function GET_PAGE_LOADING(state) {
    return state.pageLoading;
  },
  GET_PAGE_LOADING_TYPE: function GET_PAGE_LOADING_TYPE(state) {
    return state.pageLoadingType;
  }
};
var mutations = {
  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_UPDATE_COMPLETE: function SET_UPDATE_COMPLETE(state, data) {
    state.updateComplete = data;
  },
  SET_SUPPORTED_DEVICE: function SET_SUPPORTED_DEVICE(state, data) {
    state.supportedDevice = data;
  },
  SET_APP_UPDATE_READY: function SET_APP_UPDATE_READY(state, data) {
    state.updateReady = data;
  },
  SET_APP_REGISTRATION: function SET_APP_REGISTRATION(state, data) {
    state.registration = data;
  },
  SET_APP_REFRESHING: function SET_APP_REFRESHING(state, data) {
    state.refreshing = data;
  },
  SET_PAGE_LOADING: function SET_PAGE_LOADING(state, data) {
    state.pageLoading = data;
  },
  SET_PAGE_LOADING_TYPE: function SET_PAGE_LOADING_TYPE(state, data) {
    state.pageLoadingType = data;
  }
};
var actions = {
  updateApp: function updateApp(_ref) {
    var state = _ref.state,
        commit = _ref.commit;
    // Reset any relevant loading states before an app update to avoid the user becoming blocked.
    commit('settings/apiInProgress', false, {
      root: true
    });
    commit('responses/sending', false, {
      root: true
    });
    commit('SET_APP_UPDATE_READY', false);

    if (state.registration.waiting) {
      state.registration.waiting.postMessage('skipWaiting');
    }
  }
};
export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
};